import { createContext } from 'react';

type CrosshairConfig = {
  horizontalHidden?: boolean;
  verticalHidden?: boolean;
  cursor?: 'default';
};

export type ChartVariantConfig = {
  crosshair?: CrosshairConfig;
};

export const ChartVariantContext = createContext<ChartVariantConfig>({});
